// extracted by mini-css-extract-plugin
export var link = "nav-module--link--hJKqh";
export var nav = "nav-module--nav--mH1pZ";